import { render, staticRenderFns } from "./TicketStatus.vue?vue&type=template&id=4d2ed118&scoped=true&"
import script from "./TicketStatus.vue?vue&type=script&lang=js&"
export * from "./TicketStatus.vue?vue&type=script&lang=js&"
import style0 from "./TicketStatus.vue?vue&type=style&index=0&id=4d2ed118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ed118",
  null
  
)

export default component.exports